export type VariacaoFormatType = 'valor' | 'porcentagem';
export type VariacaoMetricKind = 'currency' | 'quantity';

export function formatVariacaoCurvaCell(params: {
  type: VariacaoFormatType;
  metricKind: VariacaoMetricKind;
  valor?: number | null;
  percentual?: number | null;
  found: boolean;
}): string {
  if (params.type === 'valor') {
    const value = params.found ? Number(params.valor ?? 0) : 0;
    if (params.metricKind === 'quantity') {
      return String(value);
    }
    return value.toLocaleString('pt-br', {
      style: 'currency',
      currency: 'BRL',
    });
  }

  const percentual = params.found ? params.percentual : 0;
  const asString = percentual === null || percentual === undefined ? 'NaN' : String(percentual);
  if (asString === 'NaN' || asString === '-Infinity' || asString === 'Infinity') {
    return '0.00%';
  }
  return `${Number(percentual).toFixed(2)}%`;
}
